"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NavigationItemWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _MenuItem = _interopRequireDefault(require("../../MenuItem"));
var _excluded = ["className", "hasSubsection", "isSubsectionOpened"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "navigationItemWrapper": "XRM-B4",
  "subsectionOpen": "LQHiHU"
};
var root = 'root';
var selected = 'selected';
var NavigationItemWrapper = exports.NavigationItemWrapper = function NavigationItemWrapper(_ref) {
  var className = _ref.className,
    hasSubsection = _ref.hasSubsection,
    isSubsectionOpened = _ref.isSubsectionOpened,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], _extends({
    classes: {
      root: root,
      selected: selected
    },
    className: (0, _clsx["default"])(className, styles.navigationItemWrapper, hasSubsection && isSubsectionOpened && styles.subsectionOpen)
  }, rest));
};
NavigationItemWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  hasSubsection: _propTypes["default"].bool,
  isSubsectionOpened: _propTypes["default"].bool
} : {};
var _default = exports["default"] = NavigationItemWrapper;